import React, { useEffect } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Col, Container, Row ,Card,ProgressBar,Button} from 'react-bootstrap'
import MealCard from '../Components/MealCard/MealCard'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, Tooltip, Legend } from 'recharts';
import { Sun, Utensils, Moon, Users } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdminOrders } from '../hooks/order'
function HomeDashboard() {
  const dispatch=useDispatch()
  const dayMap = {
  sat: "السبت",
  sun: "الأحد",
  mon: "الاثنين",
  tue: "الثلاثاء",
  wed: "الأربعاء",
  thu: "الخميس",
  fri: "الجمعة",
};
;
    const { list: weekList } = useSelector((state) => state.week);
      const { list: orders } = useSelector((state) => state.order);const todayKeyMap = ['sun','mon','tue','wed','thu','fri','sat'];
      console.log(orders);
      
const todayKey = todayKeyMap[new Date().getDay()];
console.log(todayKey);

const trainees = orders?.trainees?.items || [];

const breakfastCount = trainees.filter(t =>
  t.days?.[todayKey]?.includes(10)
).length;

const lunchCount = trainees.filter(t =>
  t.days?.[todayKey]?.includes(11)
).length;

const dinnerCount = trainees.filter(t =>
  t.days?.[todayKey]?.includes(12)
).length;
    
const chartData = Object.keys(dayMap).map((dayKey) => {
  let breakfast = 0;
  let lunch = 0;
  let dinner = 0;

  trainees.forEach((t) => {
    const meals = t.days?.[dayKey] || [];

    if (meals.includes(10)) breakfast++;
    if (meals.includes(11)) lunch++;
    if (meals.includes(12)) dinner++;
  });

  return {
    day: dayMap[dayKey],
    breakfast,
    lunch,
    dinner,
  };
});
const maxDay = chartData.reduce((max, day) => {
  const total = day.breakfast + day.lunch + day.dinner;
  return total > (max.total || 0)
    ? { ...day, total }
    : max;
}, {})
const totalWeekMeals = chartData.reduce((sum, day) => {
  return sum + day.breakfast + day.lunch + day.dinner;
}, 0);

  const today = new Date();

    const currentWeek = weekList.find(week => {
    const start = new Date(week.start_date);
    const end = new Date(week.end_date);

    return today >= start && today <= end;
  });
  console.log(currentWeek);
  
useEffect(() => {
  if (currentWeek?.id) {
    dispatch(fetchAdminOrders(currentWeek.id));
  }
}, [dispatch])
// const chartData = [
//   { day: 'الاثنين', breakfast: 150, lunch: 200, dinner: 132 },
//   { day: 'الثلاثاء', breakfast: 180, lunch: 250, dinner: 150 },
//   { day: 'الأربعاء', breakfast: 250, lunch: 400, dinner: 200 }, // ذروة
//   { day: 'الخميس', breakfast: 200, lunch: 300, dinner: 180 },
//   { day: 'الجمعة', breakfast: 160, lunch: 220, dinner: 140 },
//   { day: 'السبت', breakfast: 240, lunch: 380, dinner: 190 }, // ذروة
//   { day: 'الأحد', breakfast: 120, lunch: 150, dinner: 100 },
// ];
  return (
    <div>
<AuthNavbar/>
<Container>
<Row className="mb-4">
        <Col md={4}>
          <MealCard title="فطور اليوم" count={breakfastCount} status="نشط" time="08:30 AM" icon={<Sun size={20}/>} color="#e8f5e9" />
        </Col>
        <Col md={4}>
          <MealCard title="غداء اليوم" count={lunchCount}  status="نشط" time="12:30 PM" icon={<Utensils size={20}/>} color="#fffde7" />
        </Col>
        <Col md={4}>
          <MealCard title="عشاء اليوم" count={dinnerCount}  status="نشط" time="07:00 PM" icon={<Moon size={20}/>} color="#e8eaf6" />
        </Col>
      </Row>
      <Row className="g-4">
        {/* إحصائيات المستفيدين */}
        {/* <Col lg={4}>
          <Card className="border-0 shadow-sm p-4 h-100">
            <div className="d-flex align-items-center mb-4">
              <div className="bg-success bg-opacity-10 p-2 rounded me-3">
                <Users size={24} className="text-success" />
              </div>
              <h5 className="mb-0 fw-bold">إجمالي المستفيدين</h5>
            </div>
            
            <div className="mb-4">
              <div className="d-flex justify-content-between mb-1">
                <span className="text-muted">العدد الحالي</span>
                <span className="fw-bold">1,240</span>
              </div>
              <ProgressBar variant="success" now={75} style={{ height: '10px' }} />
            </div>

            <Row className="g-2 text-center mb-4">
        
        
            </Row>

            <Button variant="outline-success" className="w-100 mt-auto">فتح سجل المستفيدين</Button>
          </Card>
        </Col> */}

        {/* الرسم البياني لاستهلاك الوجبات */}
        <Col lg={12}>
      <Card className="border-0 shadow-sm p-4">
      <div className="d-flex justify-content-between align-items-center mb-4 text-end">
        <div>
          <h5 className="fw-bold mb-1">تحليلات الوجبات الأسبوعية</h5>
          <p className="text-muted small">مقارنة بين الفطور والغداء والعشاء</p>
        </div>
      </div>

      <div style={{ width: '100%', height: 350 }}>
        <ResponsiveContainer>
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <XAxis dataKey="day" axisLine={false} tickLine={false} />
            <YAxis hide />
            <Tooltip 
              contentStyle={{ borderRadius: '10px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            />
            <Legend verticalAlign="top" align="right" iconType="circle" />
            
            {/* الأعمدة المتراكمة */}
            <Bar dataKey="breakfast" name="الفطور" stackId="a" fill="#99F6E4" radius={[0, 0, 0, 0]} />
            <Bar dataKey="lunch" name="الغداء" stackId="a" fill="#0D9488" radius={[0, 0, 0, 0]} />
            <Bar dataKey="dinner" name="العشاء" stackId="a" fill="#134E4A" radius={[5, 5, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* ملخص إحصائي سريع بالأسفل */}
      <Row className="mt-4 g-2 text-center">
        <Col>
          <div className="p-2 bg-light rounded">
            <small className="text-muted d-block">عدد الوجبات االاسبوعية</small>
            <span className="fw-bold">{totalWeekMeals} وجبة</span>
          </div>
        </Col>
        <Col>
          <div className="p-2 bg-light rounded">
            <small className="text-muted d-block">أعلى استهلاك</small>
            <span className="fw-bold text-success">{maxDay?.day}</span>
          </div>
        </Col>
      </Row>
    </Card>
        </Col>
      </Row>
      {/* <Row>
        <Col lg={3}>
          <Card className="border-0 shadow-sm p-3 h-100">
            <div className="d-flex align-items-center mb-3">
              <div className="bg-light p-2 rounded me-2"><Users size={20} className="text-success"/></div>
              <h6 className="mb-0">إجمالي المسجلين</h6>
            </div>
            <p className="small text-muted mb-1">عدد المستفيدين</p>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="fw-bold">1,240</h3>
            </div>
            <ProgressBar variant="success" now={80} className="my-3" style={{height: '8px'}} />
            <Row className="text-center">
              <Col>
                <small className="text-muted d-block">جدد اليوم</small>
                <span className="fw-bold">+14</span>
              </Col>
        
            </Row>
            <Button variant="outline-secondary" className="mt-4 w-100 py-2">عرض دليل المستفيدين</Button>
          </Card>
        </Col>

        <Col lg={9}>
          <Card className="border-0 shadow-sm p-4">
            <h5 className="fw-bold">توجهات ذروة الاستهلاك</h5>
            <p className="small text-muted">تحليل أسبوعي لاستخدام صالة الطعام</p>
            <div style={{ width: '100%', height: 250 }}>
              <ResponsiveContainer>
                <BarChart data={data}>
                  <XAxis dataKey="day" axisLine={false} tickLine={false} />
                  <Bar dataKey="value" radius={[5, 5, 0, 0]}>
                    {data.map((entry, index) => (
                      <Cell key={index} fill={entry.value > 70 ? '#00897b' : '#b2dfdb'} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </Card>
        </Col>
      </Row> */}
</Container>
    </div>
  )
}

export default HomeDashboard
